import { c as _c } from "react/compiler-runtime";
import React from "react";
import { useWidgetSelector } from "../../../store/store";
import { LoadingButtonSpinner } from "../../../../Spinner/LoadingButtonSpinner";
import { State } from "../../../store/state";
import { EffektButton } from "../../../../EffektButton/EffektButton";
import styles from "./NavigationButtons.module.scss";

/**
 * While a request is in flight the button shows a spinner and ignores clicks, so a second
 * click can't start a second registration or agreement draft.
 */
const useLoadingGuard = onClick => {
  const $ = _c(6);
  const loading = useWidgetSelector(_temp);
  let t0;
  if ($[0] !== loading || $[1] !== onClick) {
    t0 = e => {
      if (loading) {
        e.preventDefault();
        return;
      }
      onClick?.(e);
    };
    $[0] = loading;
    $[1] = onClick;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const guardedOnClick = t0;
  let t1;
  if ($[3] !== guardedOnClick || $[4] !== loading) {
    t1 = {
      loading,
      guardedOnClick
    };
    $[3] = guardedOnClick;
    $[4] = loading;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
export const NextButton: React.FC<React.ButtonHTMLAttributes<HTMLButtonElement>> = t0 => {
  const $ = _c(12);
  let children;
  let onClick;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      onClick,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = onClick;
    $[3] = props;
  } else {
    children = $[1];
    onClick = $[2];
    props = $[3];
  }
  const {
    loading,
    guardedOnClick
  } = useLoadingGuard(onClick);
  const t1 = loading || undefined;
  let t2;
  if ($[4] !== children || $[5] !== loading) {
    t2 = loading ? <LoadingButtonSpinner /> : children;
    $[4] = children;
    $[5] = loading;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== guardedOnClick || $[8] !== props || $[9] !== t1 || $[10] !== t2) {
    t3 = <EffektButton {...props} className={styles.button} onClick={guardedOnClick} aria-busy={t1}>{t2}</EffektButton>;
    $[7] = guardedOnClick;
    $[8] = props;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};
export const SubmitButton: React.FC<React.ButtonHTMLAttributes<HTMLButtonElement>> = t0 => {
  const $ = _c(12);
  let children;
  let onClick;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      onClick,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = onClick;
    $[3] = props;
  } else {
    children = $[1];
    onClick = $[2];
    props = $[3];
  }
  const {
    loading,
    guardedOnClick
  } = useLoadingGuard(onClick);
  const t1 = loading || undefined;
  let t2;
  if ($[4] !== children || $[5] !== loading) {
    t2 = loading ? <LoadingButtonSpinner /> : children;
    $[4] = children;
    $[5] = loading;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== guardedOnClick || $[8] !== props || $[9] !== t1 || $[10] !== t2) {
    t3 = <EffektButton {...props} className={styles.button} onClick={guardedOnClick} aria-busy={t1}>{t2}</EffektButton>;
    $[7] = guardedOnClick;
    $[8] = props;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};
function _temp(state) {
  return state.layout.loading;
}